import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import streamLoading from "./assets/streamLoading.png";
import MarkedContent from "./common/markdownWrapper";
import { getDefaultComponentStyle } from "./utils/defaultStyles";
// import { eventBus } from 'renderer/_public/business-tools/event-bus';

export default ({
  data,
  getText,
  isStreaming,
}: {
  data: IMultiElementCombineMsg.IPluginElem;
  getText: (text: IMultiElementCombineMsg.IText) => string;
  isStreaming: boolean;
}) => {
  const { description, content, status, id } = data;
  const [isExpand, setIsExpand] = useState(false);
  const [winHeight, setWinHeight] = useState(window.innerHeight);
  const [outputDone, setOutputDone] = useState(status === "stop");
  const [pluginDesc, setPluginDesc] = useState("");
  const style = getDefaultComponentStyle(data);

  useEffect(() => {
    // 整个卡片结束，plugin即结束
    const outDone = status === "stop" || !isStreaming;
    setOutputDone(outDone);
    // !outDone ? eventBus.emit('isMarkedStreaming', true) : eventBus.emit('isMarkedStreaming', false);
  }, [status, isStreaming]);

  useEffect(() => {
    const onResizeWindow = () => {
      setWinHeight(window.innerHeight);
    };
    window.addEventListener("resize", onResizeWindow);
    return () => {
      window.removeEventListener("resize", onResizeWindow);
    };
  }, []);

  useEffect(() => {
    if (!description) return;
    getDescription();
  }, [description]);

  const getDescription = () => {
    const text = getText(description) || "";
    if (!text && isStreaming) return;

    const regex = /\{\{(.*?)\}\}/;
    if (!regex.test(text)) return setPluginDesc(text);

    const highlight = text.match(regex) || [];
    if (highlight.length < 2) return setPluginDesc(text);

    return setPluginDesc(
      text.replace(regex, `<span class=${"pluginName"}>${highlight[1]}</span>`)
    );
  };

  return (
    <div
      className={"sscard-pluginBox"}
      onClick={(e) => e.stopPropagation()}
      id={id}
      style={style}
    >
      <div
        className={`${"header"} ${outputDone ? "outDone" : ""}`}
        onClick={() => setIsExpand(!isExpand)}
      >
        <span
          className={"descPre"}
          dangerouslySetInnerHTML={{ __html: pluginDesc }}
        ></span>
        {!outputDone && <img className="loading" src={streamLoading} />}
        <span
          className={`${"suffixIcon"} iconfont-yach yach-youjiantoubeifen83`}
        ></span>
      </div>
      <Modal
        visible={isExpand}
        closeIcon={
          <span
            className={`${"close_icon"} iconfont-yach yach-quanju-dankuang-guanbi-moren`}
          ></span>
        }
        onCancel={() => setIsExpand(false)}
        // @ts-ignore
        getContainer={document.getElementById(id)}
        style={{ height: winHeight - 200 }}
        title={null}
        footer={null}
      >
        <MarkedContent
          idClient={`${id}`}
          content={{
            contentPc: getText(content),
            outputDone,
          }}
        />
      </Modal>
    </div>
  );
};
